"use client";

import React from "react";
import { AppHeaderPrimary } from "components/layout/AppHeader";
import PageLayout from "components/layout/PageLayout";
import { useParams, usePathname } from "next/navigation";
import useIsAllocationDisabled from "./invest/[slug]/place-allocation/useIsAllocationDisabled";

function Layout({ children }: { children: React.ReactNode }) {
	const pathname = usePathname();
	const { slug } = useParams<{ slug?: string }>();

	const isAllocationDisabled = useIsAllocationDisabled();

	if (pathname.includes("/place-allocation")) {
		return <>{children}</>;
	}

	const loginUrl = slug && `/invest/${slug}/place-allocation/account`;

	return (
		<>
			<AppHeaderPrimary
				loginUrl={!isAllocationDisabled ? loginUrl : undefined}
			/>
			<PageLayout>{children}</PageLayout>
		</>
	);
}

export default Layout;
